import Alert from '@amzn/awsui-components-react/polaris/alert';
import Button from '@amzn/awsui-components-react/polaris/button';
import { AWSConsoleLogin, useLazyRequest } from '@amzn/event-engine-js-utils';
import { state as contentTypeState } from 'atoms/content-type';
import { state as navigationContentState } from 'atoms/navigation-content';
import { AWSError } from 'aws-sdk';
import { useEventParticipant } from 'hooks';
import React, { useCallback, useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import { EEEvents, ErrorMessage } from 'services';
import { i18nStrings } from 'utils/constants';

const PERSONA = 'ws_participant';

const TeamAccountLogin = () => {
    const { getParticipant } = useEventParticipant();
    const [error, setError] = useState<string>();
    const [
        getParticipantTeamLoginLink,
        { data: teamLoginLink, isError: teamLoginLinkError },
    ] = useLazyRequest<typeof EEEvents.getParticipantTeamLoginLink, AWSError>(
        EEEvents.getParticipantTeamLoginLink,
        {}
    );
    const handleLogin = useCallback(() => {
        const participantId = getParticipant();
        if (!participantId) {
            setError(
                i18nStrings.event.notifications.noCurrentParticipant.content
            );
            return;
        }
        getParticipantTeamLoginLink(participantId);
    }, []);
    const setContentType = useSetRecoilState(contentTypeState);
    const setNavigationContent = useSetRecoilState(navigationContentState);

    useEffect(() => {
        setContentType('form');
        setNavigationContent(null);

        () => {
            setContentType('default');
        };
    }, []);

    useEffect(() => {
        if (teamLoginLink?.loginLink) {
            window.location.href = teamLoginLink.loginLink;
        }
    }, [teamLoginLink]);

    useEffect(() => {
        teamLoginLinkError &&
            setError(ErrorMessage.getMessage(teamLoginLinkError));
    }, [teamLoginLinkError]);

    if (error) {
        return (
            <Alert
                type="error"
                action={
                    <Button onClick={window.close}>
                        {i18nStrings.closeWindow}
                    </Button>
                }>
                {error}
            </Alert>
        );
    }

    return (
        <AWSConsoleLogin details={{ role: PERSONA }} onLogin={handleLogin} />
    );
};

export default TeamAccountLogin;
